import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Button } from '@hub/button';
import { Link } from '@hub/link';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardButton = _ref => {
  let {
    children,
    onClick,
    isDisabled,
    variant = 'solid',
    href,
    ariaLabel,
    target,
    as: As,
    sx
  } = _ref;
  const MaybeLink = href === undefined ? undefined : Link;
  return /*#__PURE__*/_jsx(Button, {
    as: As !== null && As !== void 0 ? As : MaybeLink,
    href: href,
    target: target,
    ariaLabel: ariaLabel,
    colorScheme: "surfacePrimaryWithText",
    sx: _objectSpread({
      paddingX: 'spacing-sm',
      paddingY: 'spacing-md',
      textTransform: 'uppercase',
      minWidth: ['100%', null, 'size-13', 'size-13'],
      minHeight: 'size-8',
      textDecoration: 'none !important'
    }, sx),
    variant: variant,
    onClick: onClick,
    isDisabled: isDisabled,
    "data-id": "standard-button_index_StandardButton_Button",
    children: children
  });
};